import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-390f4326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navlist" }

import WipBanner from '@/components/WipBanner.vue';

interface Props {
  listedPages: Array<string>,
  showWipBanner: boolean,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NavAndTitleBarDesktop',
  props: {
    listedPages: null,
    showWipBanner: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  listedPages: Array<string>,
  showWipBanner: boolean,
};




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("menu", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listedPages, (p) => {
        return (_openBlock(), _createElementBlock("li", { key: p }, [
          _createVNode(_component_router_link, {
            to: { name: p }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$router.resolve({ name: p }).meta.navTitle), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ]),
    (props.showWipBanner)
      ? (_openBlock(), _createBlock(WipBanner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$route.meta.headerTitle), 1)
  ]))
}
}

})